import { useEffect, useState } from "react"; //useLayoutEffect
import { FHeader, FItem, FCard, FTypo } from "ferrum-design-system";
import { useHistory, Link } from "react-router-dom";
import { PATH_AUTH, PATH_DASHBOARD } from "../../routes/paths";
import {
  useAlgoSignerWalletConnector,
  useWalletConnector,
  WalletConnector,
  useKeplrWalletConnector,
} from "foundry";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import {
  getCABNInformation,
  getFRMBalance,
  getTokenInformationFromWeb3,
  localStorageHelper,
  TruncateWithoutRounding,
} from "../../utils/global.utils";
import {
  COMMUNITY_ROLE_TAG,
  ME_TAG,
  TOKEN_TAG,
  ORG_ROLE_TAG,
  tokenFRMBSCMainnet,
  tokenFRMxBSCMainnet,
  APELPCFRMBNBTokenContractAddress,
  APELPCFRMxBNBTokenContractAddress,
  cFRMTokenContractAddress,
  cFRMxTokenContractAddress,
  TOKEN_TAG_V3,
  arbitrumTestTokenContractAddress,
  tokenArbTestFrmMainnet,
  networksMap,
  IS_MULTISWAP,
} from "../../utils/const.utils";
import { getFormattedBalance } from "../../utils/global.utils";
import { ConnectedWalletAccount } from "../../utils/connect-wallet/ConnectedWalletAccount";
import { ConnectWalletsInfo } from "../../utils/connect-wallet/ConnectWalletsInfo";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { ConnectButton } from "../../components/bridge/components/WalletConnectorButton";
import * as CrucibleActions from "../../components/crucible/redux/CrucibleActions";
import * as walletAuthenticatorActions from "../../components/common/wallet-authentication/redux/walletAuthenticationActions";
import profileIcon from "../../assets/ms-new-images/icons/user-profile-icon.png";
import Web3 from "web3";

const DashboardHeader = ({ title }: any) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    isConnected,
    isConnecting,
    walletAddress,
    walletBalance,
    web3Sdk,
    currentNetworkChainId,
  } = useWalletConnector();
  const { isAlgoConnected } = useAlgoSignerWalletConnector();
  const { isKeplrConnected, connectedKeplrWalletAddress, keplrWalletBalance } =
    useKeplrWalletConnector();

  const {
    meV2,
    applicationUserToken,
    tokenData,
    connectedNetwork,
    theme,
    swapAndWithdrawTxStatus,
  } = useSelector((state: RootState) => ({
    ...state.walletAuthenticator,
    ...state.crucible,
    ...state.config,
    ...state.networks,
    ...state.swap,
  }));

  const [nativeTokenBalance, setNativeTokenBalance] = useState("0");
  const [frmBalance, setFrmBalance] = useState("0");

  useEffect(() => {
    if (meV2 && meV2.role === COMMUNITY_ROLE_TAG) {
      if (isConnecting === false && isConnected === false) {
        handleLogout();
      }
    }
    // eslint-disable-next-line
  }, [isConnected, isConnecting]);

  // console.log(web3Sdk, walletAddress, currentNetworkChainId, isProcessing);
  useEffect(() => {
    if (connectedNetwork && web3Sdk && walletAddress && currentNetworkChainId) {
      const web3 = new Web3(connectedNetwork?.rpcUrl);
      web3.eth.getBalance(walletAddress).then((res: any) => {
        const result = Web3.utils.fromWei(res);
        setNativeTokenBalance(result);
      });
      if (currentNetworkChainId === 56) {
        getFRMBalance(
          web3,
          walletAddress,
          "0xA719b8aB7EA7AF0DDb4358719a34631bb79d15Dc",
          setFrmBalance
        );
      } else if (currentNetworkChainId === 42161) {
        getFRMBalance(
          web3,
          walletAddress,
          "0x9f6AbbF0Ba6B5bfa27f4deb6597CC6Ec20573FDA",
          setFrmBalance
        );
      }
      loadTokenData(web3Sdk);
    }
    // eslint-disable-next-line
  }, [web3Sdk, walletAddress, currentNetworkChainId, swapAndWithdrawTxStatus]);

  // useEffect(() => {
  //   // loadTokenData(web3Sdk);
  //   // if (web3Sdk && isProcessed === true && isProcessing === false) {
  //   if (web3Sdk && isProcessing === false) {
  //     loadTokenData(web3Sdk);
  //   }
  //   // eslint-disable-next-line
  // }, [web3Sdk, isProcessed, isProcessing]);

  const handleLogout = async () => {
    try {
      if (localStorageHelper.load(ME_TAG)?.role === ORG_ROLE_TAG) {
        history.push(PATH_AUTH.orgLogin);
      }
      localStorageHelper.removeItem(ME_TAG);
      localStorageHelper.removeItem(TOKEN_TAG);
      localStorage.removeItem(TOKEN_TAG_V3);
      dispatch(
        walletAuthenticatorActions.removeSession({
          userToken: applicationUserToken,
        })
      );
    } catch (e) {}
  };

  const loadTokenData = async (networkClient: any, network: string = "BSC") => {
    const currencyByCabn = theme.crucibleConfig?.baseCurrency?.cabn || "";
    let crucibleTokens: { [key: string]: string }[] = [];
    if (currencyByCabn) {
      crucibleTokens = [
        {
          currency: currencyByCabn.tokenContractAddress,
          network: (theme.crucibleConfig?.crucibleFarms || [])[0]?.network,
          token: currencyByCabn.currency?.symbol,
        },
      ];
    }

    if (theme.crucibleConfig?.crucibleFarms.length > 0) {
      crucibleTokens.push({
        currency: (theme.crucibleConfig?.crucibleFarms || [])[0]?.contract,
        network: (theme.crucibleConfig?.crucibleFarms || [])[0]?.network,
        token: (theme.crucibleConfig?.crucibleFarms || [])[0]?.internalName,
      });
    }
    const networkTokens = crucibleTokens.filter(
      (e) => e.network === (networksMap as any)[currentNetworkChainId]
    );
    for (let item of networkTokens) {
      const tokenDetails = await getTokenInformationFromWeb3(
        networkClient,
        walletAddress,
        item.currency
      );
      const cabnDetails = await getCABNInformation(item.currency);
      let finalData = { ...tokenDetails, ...cabnDetails };
      if (!!finalData) {
        dispatch(
          CrucibleActions.updateTokenData({
            token: item.token,
            ...finalData,
          })
        );
      }
    }
  };

  const GlobalStyles = createGlobalStyle`
    .new-bg-header {
      background: none !important;
      .no-left-margin {
        .f-btn, f-btn-primary, f-btn {
          border-color: ${theme?.colors?.primary} !important;
          color: ${theme?.colors?.primaryLight} !important;
        }
      }
      .ms-connected-wallets-info {
        outline-color: ${theme?.colors?.backgroundLight} !important;
      }
      .wallet-amount-card {
        background: ${theme?.colors?.background} !important;
        color: ${theme?.colors?.primaryLight} !important;
      }
      .primary-color {
        color: ${theme?.colors?.primary} !important;
      }
    }
  `;

  const currencyByCabn = theme.crucibleConfig?.baseCurrency?.cabn || "";
  const activeToken =
    currencyByCabn?.currency?.symbol ||
    tokenData["FRMBSC"]?.symbol ||
    tokenData["FRMBSC"]?.symbol ||
    "FRM";
  //@ts-ignore
  const logo = tokenData[activeToken]?.logo || tokenData["FRMBSC"]?.logo;

  if (IS_MULTISWAP) {
    return (
      <FHeader showLogo={false} titleText={title} className={"new-bg-header"}>
        <div className="profile-data">
          <FItem align="right" display={"flex"} className="no-left-margin">
            <>
              {isConnected && walletAddress ? (
                <>
                  <FCard variant={"primary"} className={"wallet-amount-card"}>
                    <FItem display={"flex"} alignY="center">
                      <img
                        src={
                          "https://etherscan.io/token/images/ferrumnetwork_32.png?=v454"
                        }
                        height="22px"
                        width="22px"
                        style={{ marginRight: "3px" }}
                        alt=""
                      />
                      <span className=" f-pl--2 custom-font-size-13">
                        {TruncateWithoutRounding(frmBalance, 5)}
                      </span>
                      <span className="primary-color f-pl--4 custom-font-size-13">
                        {activeToken}
                      </span>
                    </FItem>
                  </FCard>

                  <FCard className={"wallet-amount-card"} variant={"primary"}>
                    <FTypo
                      size={14}
                      weight={400}
                      color={theme?.colors?.primaryLight}
                    >
                      {TruncateWithoutRounding(nativeTokenBalance, 5)}{" "}
                      {connectedNetwork &&
                        connectedNetwork?.networkCurrencySymbol}
                    </FTypo>
                  </FCard>
                </>
              ) : null}
              {connectedKeplrWalletAddress && (
                <>
                  <FCard
                    variant={"primary"}
                    className={
                      "no-left-margin custom-padding-0 custom-border-radius-4 custom-min-width-150 new-bg-body"
                    }
                  >
                    <FItem display={"flex"} alignY="center">
                      <FCard
                        variant={"primary"}
                        className={
                          "d-flex custom-padding-10 overflow-visible new-bg-body header-tokens-info"
                        }
                      >
                        <img
                          src={
                            tokenData["FRMBSC"]?.logo
                              ? tokenData["FRMBSC"]?.logo
                              : "https://bscscan.com/token/images/ferrumnetwork_32.png?=v1"
                          }
                          height="22px"
                          width="22px"
                          style={{ marginRight: "3px" }}
                          alt=""
                        />
                        <span className="primary-color f-pl--2 custom-font-size-13">
                          {tokenData["FRMBSC"]
                            ? TruncateWithoutRounding(
                                tokenData["FRMBSC"]?.balance,
                                3
                              )
                            : "0"}{" "}
                          <span className="white-color">
                            {tokenData["FRMBSC"]?.symbol
                              ? tokenData["FRMBSC"]?.symbol
                              : "FRM"}
                          </span>
                        </span>
                      </FCard>
                    </FItem>
                  </FCard>
                  <FCard className={"wallet-amount-card"} variant={"primary"}>
                    <FTypo
                      size={14}
                      weight={400}
                      color={theme?.colors?.primaryLight}
                    >
                      {TruncateWithoutRounding(keplrWalletBalance, 3)}{" "}
                      {connectedNetwork &&
                        connectedNetwork?.networkCurrencySymbol}
                    </FTypo>
                  </FCard>
                </>
              )}
              <WalletConnector
                WalletConnectView={ConnectWalletsInfo}
                WalletConnectModal={ConnectedWalletAccount}
                WalletConnectViewProps={{
                  className: isConnected ? "no-left-margin" : "no-left-margin",
                }}
              />
              {!isConnected && !isAlgoConnected && !isKeplrConnected ? (
                <ConnectButton
                  title="CONNECT"
                  className="no-left-margin connect-wallet-button-new"
                />
              ) : null}
              {/* {isConnected ? (
                <Link to={PATH_DASHBOARD.general.profile}>
                  <img height={"40px"} src={profileIcon} alt="profileIcon" />
                </Link>
              ) : null} */}
            </>
          </FItem>
        </div>
      </FHeader>
    );
  } else
    return (
      <ThemeProvider theme={theme}>
        <FHeader showLogo={false} titleText={title} className={"new-bg-header"}>
          <div className="profile-data">
            <FItem align="right" display={"flex"} className="no-left-margin">
              <>
                {isConnected && walletAddress && (
                  <>
                    <FCard variant={"primary"} className={"wallet-amount-card"}>
                      <FItem display={"flex"} alignY="center">
                        <img
                          src={
                            "https://etherscan.io/token/images/ferrumnetwork_32.png?=v454"
                          }
                          height="22px"
                          width="22px"
                          style={{ marginRight: "3px" }}
                          alt=""
                        />
                        <span className="primary-color f-pl--2 custom-font-size-13">
                          {TruncateWithoutRounding(frmBalance, 5)}
                          {/* {tokenData[activeToken]
                            ? TruncateWithoutRounding(
                                tokenData[activeToken]?.balance,
                                3
                              )
                            : tokenData["FRMBSC"]
                            ? TruncateWithoutRounding(
                                tokenData["FRMBSC"]?.balance,
                                3
                              )
                            : "0"}{" "} */}
                        </span>
                        <span className="white-color f-pl--4 custom-font-size-13">
                          {activeToken}
                        </span>
                      </FItem>
                    </FCard>

                    <FCard className={"wallet-amount-card"} variant={"primary"}>
                      <FTypo
                        size={14}
                        weight={400}
                        color={theme?.colors?.primaryLight}
                      >
                        {TruncateWithoutRounding(nativeTokenBalance, 5)}{" "}
                        {connectedNetwork &&
                          connectedNetwork?.networkCurrencySymbol}
                      </FTypo>
                    </FCard>
                  </>
                )}
                {connectedKeplrWalletAddress && (
                  <>
                    <FCard
                      variant={"primary"}
                      className={
                        "no-left-margin custom-padding-0 custom-border-radius-4 custom-min-width-150 new-bg-body"
                      }
                    >
                      <FItem display={"flex"} alignY="center">
                        <FCard
                          variant={"primary"}
                          className={
                            "d-flex custom-padding-10 overflow-visible new-bg-body header-tokens-info"
                          }
                        >
                          <img
                            src={
                              tokenData["FRMBSC"]?.logo
                                ? tokenData["FRMBSC"]?.logo
                                : "https://bscscan.com/token/images/ferrumnetwork_32.png?=v1"
                            }
                            height="22px"
                            width="22px"
                            style={{ marginRight: "3px" }}
                            alt=""
                          />
                          <span className="primary-color f-pl--2 custom-font-size-13">
                            {tokenData["FRMBSC"]
                              ? TruncateWithoutRounding(
                                  tokenData["FRMBSC"]?.balance,
                                  3
                                )
                              : "0"}{" "}
                            <span className="white-color">
                              {tokenData["FRMBSC"]?.symbol
                                ? tokenData["FRMBSC"]?.symbol
                                : "FRM"}
                            </span>
                          </span>
                        </FCard>
                      </FItem>
                    </FCard>
                    <FCard className={"wallet-amount-card"} variant={"primary"}>
                      <FTypo
                        size={14}
                        weight={400}
                        color={theme?.colors?.primaryLight}
                      >
                        {TruncateWithoutRounding(keplrWalletBalance, 3)}{" "}
                        {connectedNetwork &&
                          connectedNetwork?.networkCurrencySymbol}
                      </FTypo>
                    </FCard>
                  </>
                )}
                <WalletConnector
                  WalletConnectView={ConnectWalletsInfo}
                  WalletConnectModal={ConnectedWalletAccount}
                  WalletConnectViewProps={{
                    className: isConnected
                      ? "no-left-margin"
                      : "no-left-margin",
                  }}
                />
                {!isConnected && !isAlgoConnected && !isKeplrConnected ? (
                  <ConnectButton
                    title="CONNECT"
                    className="no-left-margin connect-wallet-button-new"
                  />
                ) : null}
                {/* {isConnected ? (
                  <Link to={PATH_DASHBOARD.general.profile}>
                    <img height={"40px"} src={profileIcon} alt="profileIcon" />
                  </Link>
                ) : null} */}
              </>
            </FItem>
          </div>
        </FHeader>
        <GlobalStyles />
      </ThemeProvider>
    );
};

export default DashboardHeader;
